import * as React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import FullCVPage from "../pages/full-cv-page";
import MainPage from "../pages/main/main-page";
import { AnimatePresence, motion } from "motion/react";

interface IAppRouterProps {}

const pageVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -8 },
};

const AppRouter: React.FunctionComponent<IAppRouterProps> = (props) => {
  const location = useLocation();
  return (
    <div className="relative h-full min-h-0 w-full overflow-hidden">
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={location.pathname}
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 0.22 }}
          className="w-full h-full min-h-0"
        >
          <Routes location={location}>
            <Route path="/" element={<MainPage />} />
            <Route path="/cv" element={<FullCVPage />} />

            {/* 404 */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default AppRouter;
